import { TelegramAltIcon } from "@/components/Icons"
import { Modal } from "@/components/Modal"
import { useGenericErrorToast } from "@/hooks/useGenericErrorToast"
import {
  type SharedDataJsonldReadCollectionSharedData,
  getGetUserSharedDataQueryKey,
  getGetUserSharedDatasQueryKey,
  useCancelInterBuSharedData,
} from "@/networking/api"
import { isNotNullNorUndefined } from "@/utils/ts-utils"
import { Box, Button, ModalBody, ModalFooter } from "@chakra-ui/react"
import { useQueryClient } from "@tanstack/react-query"
import { FormattedMessage } from "react-intl"

type Props = {
  isOpen: boolean
  onClose: () => void
  sharedEntity: SharedDataJsonldReadCollectionSharedData
}

export default function ShareCancelShareModal({ isOpen, onClose, sharedEntity }: Props) {
  const { mutate, isPending } = useCancelInterBuSharedData()
  const queryClient = useQueryClient()
  const genericErrorToast = useGenericErrorToast()

  const cancelShareRequest = () => {
    mutate(
      {
        id: sharedEntity.id,
      },
      {
        onSuccess: () => {
          void queryClient.invalidateQueries({
            queryKey: getGetUserSharedDataQueryKey(sharedEntity.id),
          })
          void queryClient.invalidateQueries({
            queryKey: getGetUserSharedDatasQueryKey(),
          })
          onClose()
        },
        onError: genericErrorToast,
      }
    )
  }

  return (
    <Modal
      {...{ isOpen, onClose }}
      title={<FormattedMessage id="userSharedData.modal.title_cancel" />}
      scrollBehavior="outside"
    >
      <ModalBody>
        <Box>
          <FormattedMessage
            id={
              isNotNullNorUndefined(sharedEntity.toCluster)
                ? "userSharedData.cancelShare.message"
                : "undefined"
            }
            values={{ clusterName: sharedEntity.toCluster?.name ?? "" }}
          />
        </Box>
      </ModalBody>

      <ModalFooter>
        <Button
          display="flex"
          gap="2"
          type="button"
          isLoading={isPending}
          onClick={() => cancelShareRequest()}
        >
          <FormattedMessage id="confirm" />
          <TelegramAltIcon boxSize={4} />
        </Button>
      </ModalFooter>
    </Modal>
  )
}
